<template>
  <el-dialog :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            destroy-on-close
            :append-to-body="appendToBody"
            :modal-append-to-body="appendToBody"
            @close="closeDialog" width="676px">
    <template #title>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <strong style="font-size: 16px; margin-right: 10px; color: #42444d"
          >Thêm mới trường dữ liệu</strong
        >
        <div class="d-flex align-items-center" style="gap: 8px;">
          <el-checkbox v-model="isAiAnalysis"></el-checkbox>
          <div style="font-size: 14px;;">Trường dữ liệu phục vụ phân tích AI</div>
        </div>
      </div>
    </template>
    <hr
      style="
        margin-top: 0px;
        margin-bottom: 5px;
        border: none;
        border-top: 2px solid #dcdfe9;
      "
    />
    <ValidationObserver ref="obs">
      <div class="d-flex align-items-start gap-2 mt-2" style="margin-left: 20px; margin-right: 15px">
        <div class="h-100">
          <strong class="required">Tên trường dữ liệu</strong>
          <ValidationProvider
            name="Tên trường dữ liệu"
            rules="required-input:tên trường dữ liệu"
            v-slot="{ errors }"
          >
            <el-input class="mt-2"
              placeholder="Nhập tên trường"
              v-model="title"
              style="width: 446px"
            ></el-input>
            <InputError v-if="!titleError" :message="errors[0]" />
            <span v-if="titleError" class="error-message">Vui lòng nhập tên trường dữ liệu</span> 
          </ValidationProvider>
        </div>
        <div>
          <div style="display: flex; align-items: center">
            <strong class="required">Code</strong>
            <el-tooltip class="item" effect="dark" content="Mỗi trường sẽ có một mã code riêng biệt, nhằm phục vụ cho nhập liệu công thức dễ dàng" placement="top">
              <icon-font
                :name="'icon-info'"
                style="margin-left: 4px; font-size: 12px; color: #333"
              />
            </el-tooltip>
          </div>
          <el-select
            style="width: 190px"
            class="mt-2 select-code"
            placeholder="Chọn code tương ứng"
            v-model="name"
          >
            <el-scrollbar style="max-height: 150px; overflow-y: auto;margin-bottom: -22px">
              <el-option 
                v-for="code in codeRemain" 
                :key="code" 
                :label="code" 
                :value="code">
              </el-option>
            </el-scrollbar>
          </el-select>
          <span v-if="nameError" class="error-message">Vui lòng chọn code</span>
        </div>
      </div>
    </ValidationObserver>
    <div class="d-flex mt-2" style="margin-left: 20px">
      <strong>Kiểu dữ liệu</strong>
    </div>

    <div class="d-flex  flex-wrap gap-2 mt-2" style="margin-left: 20px; margin-right: 15px">
      <div v-for="item in dataType" :key="item.type"
        class="custom-button"
        @click="changecolumnType(item.type)"
        :class="{ 'active-button': columnType === item.type }"
      >
        <div class="d-flex justify-content-between align-items-center">
          <icon-font
            class="icon-style"
            :color="columnType === item.type ? '#327ae7' : 'grey'"
            :name="item.icon"
          ></icon-font>
          {{ item.name }}
        </div>
      </div>
    </div>

    <div
      v-if="columnType === 'SingleSelect' || columnType === 'MultiSelect'"
      class="mt-2"
      style="margin-left: 20px; margin-right: 15px"
    >
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center gap-2">
          <strong class="required me-2">Danh sách lựa chọn</strong>
          <div v-if="columnType === 'SingleSelect'" class="d-flex align-items-center gap-4">
            <div class= "">
              <el-checkbox v-model="isProvince"></el-checkbox>
              <span class="ms-2">Tỉnh/Thành phố</span>
            </div>
            <div>
              <el-checkbox v-model="isWard"></el-checkbox>
              <span class="ms-2">Xã/Phường</span>
            </div>
          </div>
        </div>
        <div>
          <el-checkbox :disabled="isProvince || isWard" v-model="isColor"></el-checkbox>
          <span class="ms-2">Có màu sắc</span>
        </div>
      </div>
      <div v-if="!isProvince && !isWard" class="d-flex flex-wrap w-100 align-items-center mt-2 list-select">
        <div v-if="selectOptions.length > 0" class="d-flex flex-wrap justify-content-start me-2" >
          <div class="tag d-flex align-items-center me-2 mt-1 gap-2" v-for="item in selectOptions" :key="item.id">
            <div v-if="isColor"
              class="color" 
              :style="{ backgroundColor: item.color || getRandomColor() }"
              @mouseover="showColorPicker(item)"
              @mouseleave="item.showColors = false"
            >
              <div v-if="item.showColors" class="color-picker" >
                <div 
                  v-for="color in colors" 
                  :key="color"
                  class="color-option"
                  :class="{ 'select': item.color === color }"
                  :style="{ backgroundColor: color }"
                  @click="setColor(item, color)"
                ></div>
              </div>
            </div>
            <span class="text-overflow" style="margin-bottom: 2px; display: inline-block;max-width: 560px;">{{ item.value }}</span>
            <div @click="removeOption(item.id)">
              <icon-font style="cursor: pointer;" :name="'icon-close'" ></icon-font>
            </div>
          </div>
        </div>
        <el-input
          class="w-100 input-select flex-1"
          placeholder="Nhập lựa chọn và bấm 'Enter'"
          v-model="selectionValue"
          :disabled="isProvince || isWard"
           @keydown.native="handleKeyup"
        ></el-input>
      </div>
      <div v-else class="mt-2 p-3" style="background: #f5f7fa; border-radius: 4px; color: #606266;">
        <i class="el-icon-info" style="color: #409EFF;"></i>
        <span v-if="isProvince">Danh sách tỉnh/thành phố sẽ được tự động lấy từ hệ thống</span>
        <span v-else-if="isWard">Danh sách xã/phường sẽ được tự động lấy từ hệ thống</span>
      </div>
      <span v-if="selectError && !isProvince && !isWard" class="error-message">Vui lòng nhập ít nhất một lựa chọn cho trường này</span>
    </div>
    <div
      v-if="columnType == 'Function'"
      class="mt-2"
      style="margin-left: 20px; margin-right: 15px"
    >
      <div
        style="
          background: #eff5ff;
          border: 4px solid #eff5ff;
          color: #0a58c0;
          padding: 10px;
          border-radius: 8px;
        "
      >
        <span style="font-weight: bold">Ví dụ:</span> Công thức tính tổng số
        tiền hoa hồng của nhân viên dựa vào tổng doanh thu của đơn hàng <br />
        và % hoa hồng:
        <span style="font-weight: bold"
          >$[Doanh thu] x $[Hoa hồng (%) theo doanh thu] %</span
        >
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <div style="width: 315px" class="mt-2">
          <label class="font-weight-bold"
            ><strong>1. Chọn biến</strong
            ><span class="text-danger">*</span></label
          >
          <el-select
            placeholder="Chọn kiểu dữ liệu trả về"
            class="mt-2"
            style="width: 315px"
          ></el-select>
        </div>
        <div style="width: 315px">
          <div class="mt-2"><strong>2. Làm tròn số thập phân</strong></div>
          <div class="d-flex justify-content-between align-items-center mt-2">
            <el-input
              class="custom-el-input"
              placeholder="Làm tròn theo mặc định nếu bỏ trống"
            ></el-input>
            <div class="icon-container">
              <icon-font :name="'icon-arrow1-up'"></icon-font>
              <icon-font :name="'icon-arrow1-down'"></icon-font>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-2">
        <div class="d-flex justify-content-between align-items-center">
          <label class="font-weight-bold"
            ><strong>3. Công thức</strong
            ><span class="text-danger">*</span></label
          >
          <div class="d-flex justify-content-between align-items-center mt-2" style="gap: 4px">
            <button class="btn-operator">+</button>
            <button class="btn-operator">−</button>
            <button class="btn-operator">×</button>
            <button class="btn-operator">/</button>
            <button class="btn-operator">%</button>
          </div>
        </div>
        <el-input
          class="mt-2"
          type="textarea"
          placeholder="Nhập công thức tương ứng"
          rows="3"
        ></el-input>
      </div>
    </div>

    <!-- default value -->
    <ValidationObserver>
      <div class="mt-2" style="margin-left: 20px; margin-right: 15px;">
        <strong class="">Giá trị mặc định</strong>
        <div v-if="columnType == 'Array' || columnType == 'ArrayNumber'">
          <div class="d-flex flex-wrap w-100 align-items-center mt-2 list-select">
            <div v-if="selectOptions.length > 0" class="d-flex flex-wrap justify-content-start me-2" >
              <div class="tag d-flex align-items-center me-2 mt-1 gap-2" v-for="item in selectOptions" :key="item.id">
                <span class="text-overflow" style="margin-bottom: 2px; display: inline-block;max-width: 560px;">{{ item.value }}</span>
                <div @click="removeOption(item.id)">
                  <icon-font style="cursor: pointer;" :name="'icon-close'" ></icon-font>
                </div>
              </div>
            </div>
            <el-input
              class="w-100 input-select flex-1"
              placeholder="Nhập lựa chọn và bấm 'Enter'"
              v-model="selectionValue"
              :disabled="isProvince || isWard"
              @keydown.native="handleKeyup"
            ></el-input>
          </div>
          <span v-if="defaultValueError" class="error-message">Vui lòng nhập ít nhất một lựa chọn cho trường này</span>
        </div>
        <div v-else-if="columnType == 'SingleSelect'">
          <ValidationProvider 
            name="Giá trị mặc định"
            rules="required-input:giá trị mặc định"
          >
            <el-select class="mt-2 w-100" clearable v-model="defaultValue" placeholder="Nhập giá trị mặc định" :disabled="isProvince || isWard">
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </ValidationProvider>
        </div>
        <div v-else-if="columnType == 'MultiSelect'">
          <ValidationProvider
            name="Giá trị mặc định"
            rules="required-input:giá trị mặc định"
          >
            <el-select class=" mt-2 w-100" multiple clearable v-model="defaultValue" placeholder="Nhập giá trị mặc định">
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </ValidationProvider>
        </div>
        <div v-else-if="columnType == 'Date'">
          <ValidationProvider
            name="Giá trị mặc định"
            rules="required-input:giá trị mặc định"
          >
          <el-date-picker class="w-100 custom-pick-date" 
            v-model="defaultValue" 
            type="datetime" 
            format="HH:mm:ss dd/MM/yyyy" 
            prefix-icon="icon-date-1"
            :clearable="false"
            :default-value="defaultDate"
          >
          </el-date-picker>
          </ValidationProvider>
        </div>
        <ValidationProvider
          v-else
          name="Giá trị mặc định"
          rules="required-input:giá trị mặc định"
        >
          <el-input class="mt-2 w-100"
            placeholder="Nhập giá trị mặc định"
            v-model="defaultValue"
          ></el-input>
        </ValidationProvider>
      </div>
    </ValidationObserver>

    <div class="mt-3" style="margin-left: 20px; margin-right: 15px">
      <div class=" d-flex justify-content-between">
        <label class="font-weight-bold">
          <strong class="required">Tùy chọn hiển thị</strong>
        </label>
        <div class="d-flex justify-content-end">
          <el-checkbox v-model="displayColumnDetail" :disabled="isRequire" @change="toggleDisplayColumn('PAGE_DETAIL')">
            <span>Trang chi tiết</span>
          </el-checkbox>
          <el-checkbox v-model="displayColumnQuickCreate" :disabled="isRequire" @change="toggleDisplayColumn('QUICK_CREATE')">
            <span>Mục tạo nhanh</span>
          </el-checkbox>
          <el-checkbox v-model="displayColumnImport" :disabled="isRequire" @change="toggleDisplayColumn('FILE_IMPORT')">
            <span>File nhập dữ liệu</span>
          </el-checkbox>
        </div>
      </div>
      <span v-if="displayColumnsError" class="error-message">Vui lòng chọn vị trí hiển thị</span>
    </div>

    <hr
      style="margin-bottom: 3px; border: none; border-top: 2px solid #dcdfe9"
    />
    <div class="d-flex align-items-center justify-content-between">
      <div
        class="d-flex flex-column align-items-center justify-content-center"
        style="gap: 5px; padding: 10px 0"
      >
        <div
          class="d-flex align-items-center"
          style="gap: 8px; margin-left: 20px"
        >
          <el-checkbox v-model="isRequire"></el-checkbox>
          <div style="margin-top: 2px;">Đặt làm trường dữ liệu bắt buộc</div>
        </div>
      </div>
      <div class="d-flex mt-2" style="margin-right: 15px; margin-bottom: 8px">
        <el-button @click="closeDialog" type="info" plain>Hủy</el-button>
        <el-button type="primary" @click="createColumn" :disabled = "!isDisable"
          >Thêm trường mới</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>
  
<script>
import field from '@/lib/apis/field';

export default {
  data() {
    return {
      dialogVisible: true,
      dataType : [
        { name : 'Văn bản', type : 'Text', icon : 'icon-text-format'},
        { name : 'Số', type : 'Number', icon : 'icon-number-format'},
        {name : 'Thời gian', type : 'Date', icon : 'icon-date-1'},
        {name : 'Mảng', type : 'Array', icon : 'icon-array-data' },
        {name : 'Lựa chọn đơn', type : 'SingleSelect', icon : 'icon-single-option' },
        {name : 'Nhiều lựa chọn', type : 'MultiSelect', icon : 'icon-multiple-option' },
        {name : 'Công thức', type : 'Function', icon : 'icon-fomular' },
        {name : 'Mảng số', type : 'ArrayNumber', icon : 'icon-number-format' },
      ],
      columnType: "Text",
      name : this.codeRemain[0],
      title : '',
      isRequire : false,
      selectOptions : [],
      id : 1,
      selectionValue : '',
      isColor : false,
      colors: ['#327AE7', '#D08B20', '#218656', '#CF4343', '#7053B4', '#598C78'],
      isColorSet: false,
      displayColumns: [
        { columnDisplay: 'PAGE_DETAIL' },
        { columnDisplay: 'QUICK_CREATE' },
        { columnDisplay: 'FILE_IMPORT' },
      ],
      displayColumnDetail: true,
      displayColumnQuickCreate: true,
      displayColumnImport: true,
      nameError: false,
      titleError: false,
      displayColumnsError: false,
      selectError : false,
      defaultValueError : false,
      isDisable : false,
      defaultValue : null,
      isProvince: false,
      isWard: false,
      isAiAnalysis: false,
      source: 'USER',
    };
  },
  beforeDestroy() {
    this.dialogVisible = false;
  },
  props: {
    codeRemain : {
      type : Array,
      require : true
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    initial: {
      type: Object,
      default: null
    }
  },
  created() {
    if (this.initial) {
      if (this.initial.title) this.title = this.initial.title;
      if (this.initial.columnType) this.columnType = this.initial.columnType;
      if (Array.isArray(this.initial.selectOptions)) this.selectOptions = this.initial.selectOptions;
      if (this.initial.name) this.name = this.initial.name;
      if (this.initial.aiAnalysis !== undefined) this.isAiAnalysis = !!this.initial.aiAnalysis;
      if(this.initial.source) this.source = this.initial.source;
    }
  },
  watch: {
    name(value) {
      if (value) {
        this.nameError = false; 
      }
      this.checkDisable()
    },
    title(value) {
      if (value) {
        this.titleError = false; 
      }
      this.checkDisable()
    },
    displayColumns(value) {
      if (value.length > 0) {
        this.displayColumnsError = false;
      }
      this.checkDisable()
    },
    isRequire(newVal) {
      if (newVal) {
        this.displayColumnDetail = true;
        this.displayColumnImport = true;
        this.displayColumnQuickCreate = true;
        this.addRequiredColumns();
        this.checkDisable()
      } else {
        this.displayColumnDetail = false;
        this.displayColumnImport = false;
        this.displayColumnQuickCreate = false;
        this.removeRequiredColumns();
        this.checkDisable()
      }
    },
    isColor(newColorStatus) {
      if (newColorStatus && !this.isColorSet) {
        this.selectOptions.forEach((option) => {
          if (!option.color) {
            option.color = this.getRandomColor();
          }
        });
        this.isColorSet = true;  
      } else if (!newColorStatus) {
        this.selectOptions.forEach((option) => {
          delete option.color;
        });
        this.isColorSet = false;
      }
    },
    isProvince(newVal) {
      if (newVal) {
        this.selectOptions = [];
        this.selectionValue = '';
        this.title = "Tỉnh/Thành phố";
        this.isWard = false;
        this.selectError = false;
      }
    },
    isWard(newVal) {
      if (newVal) {
        this.selectOptions = [];
        this.selectionValue = '';
        this.title = "Xã/Phường";
        this.isProvince = false;
        this.selectError = false;

      }
    }
  },
  methods: {
    handleKeyup(event) {
      if (this.columnType === 'ArrayNumber' && event.key.length === 1 && !/[0-9.]/.test(event.key)) {
        event.preventDefault();
      }
      if (event.key === 'Backspace') {
        if (!this.selectionValue.trim()) {
          if (this.selectOptions.length > 0) {
            const lastOption = this.selectOptions[this.selectOptions.length - 1];
            this.removeOption(lastOption.id);
          }else{
            this.selectError = true;
          }
        }
        if(this.selectionValue === '' && this.selectOptions.length === 0){
          this.selectError = true;
        }
      } else if (event.key === 'Enter') {
        if (this.columnType === 'ArrayNumber') {
          const value = this.selectionValue.trim();

          const isNumber = /^-?\d+(\.\d+)?$/.test(value);

          if (!isNumber) {
            this.$message.error("Chỉ được nhập số hoặc số thập phân");
            return;
          }
        }
        this.addOption();
        this.selectError = false;
      }
    },
    getRandomColor() {
      const randomIndex = Math.floor(Math.random() * this.colors.length);
      return this.colors[randomIndex];
    },
    checkDisable() {
      this.isDisable = !!(this.name && this.title && this.displayColumns.length > 0);
    },
    addRequiredColumns() {
      const requiredColumns = ['PAGE_DETAIL', 'QUICK_CREATE', 'FILE_IMPORT'];

      requiredColumns.forEach((column) => {
        const exists = this.displayColumns.find(
          (item) => item.columnDisplay === column
        );
        if (!exists) {
          this.displayColumns.push({ columnDisplay: column });
        }
      });
    },
    removeRequiredColumns() {
      const requiredColumns = ['PAGE_DETAIL', 'QUICK_CREATE', 'FILE_IMPORT'];
      
      this.displayColumns = this.displayColumns.filter(
        (item) => !requiredColumns.includes(item.columnDisplay)
      );
    },
    changecolumnType(type) {
      this.columnType = type;
      this.selectOptions = [];
      this.selectionValue = "";
      this.defaultValue = null;
      this.isProvince = false;
      this.isWard = false;
    },
    showColorPicker(item) {
      item.showColors = true;
    },
    setColor(item, color) {
      item.color = color;
      item.showColors = false;
    },
    addOption() {
      if (this.selectionValue.trim()) {
        const exists = this.selectOptions.some(item => item.value.toLowerCase() === this.selectionValue.trim().toLowerCase());
        if (!exists) {
          const lastOption = this.selectOptions[this.selectOptions.length - 1];
          const newId = lastOption ? lastOption.id + 1 : 1;
          const newOption = {
            id : newId,
            value : this.selectionValue.trim(),
            showColors: false,
          };

          if (this.isColor) {
            const index = Math.floor(Math.random() * this.colors.length);
            newOption.color = this.colors[index];
          }
          this.selectOptions.push(newOption);
          if(this.columnType == "Array" || this.columnType == "ArrayNumber"){
            this.defaultValue = this.selectOptions.map(item=>item.value);
          }
          this.selectionValue = '';
          this.selectError = true;
        } else {
          this.alert("error", "Đã tồn tại giá trị này!");
          this.selectError = false;
        }
      }
    },
    removeOption(id) {
      this.selectOptions = this.selectOptions.filter(item => item.id !== id);
      if(this.columnType == "Array" || this.columnType == 'ArrayNumber'){
        this.defaultValue = this.selectOptions;
      }
    },
    toggleDisplayColumn(columnDisplay) {
      const index = this.displayColumns.findIndex(
        (item) => item.columnDisplay === columnDisplay
      );

      if (index !== -1) {

        this.displayColumns.splice(index, 1);
      } else {
        this.displayColumns.push({
          columnDisplay
        });
      }
    },
    closeDialog() {
      this.$emit('close');
    },
    async createColumn() {
      this.nameError = !this.name;
      this.titleError = !this.title || !this.title.trim();
      this.displayColumnsError = this.displayColumns.length === 0;

      const isSelection = this.columnType === 'SingleSelect' || this.columnType === 'MultiSelect';
      this.selectError = isSelection && (!this.selectOptions || this.selectOptions.length === 0) && !this.isProvince && !this.isWard;
      
      if ((this.nameError || this.titleError || this.displayColumnsError || this.selectError ) && (this.isProvince === false && this.isWard === false)) {
        return;
      }

      const columnExtendRequest = {
        name: this.name,
        title: this.title.trim(),
        columnType: this.columnType,
        require: this.isRequire,
        color: this.isColor,
        selectOptions: this.selectOptions,
        province: this.isProvince,
        ward: this.isWard,
        aiAnalysis : this.isAiAnalysis,
        source: this.source,
        defaultValue: (() => {
          const type = this.columnType;
          const value = this.defaultValue;

          if (["Array", "MultiSelect", "ArrayNumber"].includes(type)) {
            let arr = [];
            
            if (Array.isArray(value)) {
              arr = value;
            } else if (typeof value === "string") {
              arr = value
                .split(";;")
                .map(v => v.trim())
                .filter(v => v !== "");
            }

            if (type === "ArrayNumber") {
              arr = arr
                .map(v => Number(v))
                .filter(v => !isNaN(v));
            }

            return arr.length ? JSON.stringify(arr) : "";
          }

          if (type === "Date" && value) {
            return new Date(value).getTime();
          }

          return value;
        })()
    };
      const displayColumnRequests = this.displayColumns.map((display) => ({
        columnDisplay: display.columnDisplay,
        displayOrder: [],
      }));
      const saveColumnRequest = {
        columnExtendRequest,
        displayColumnRequests,
      };

      await this.saveColumn(saveColumnRequest);
      
    },
    async saveColumn(saveColumnRequest) {
      try {
        const processId = this.app.globalProcessId === 'all' ? 0 : this.app.globalProcessId;
        const response = await field.createColumn(saveColumnRequest, processId);

        if (response.status === "success") {
          this.$emit("addSuccess");
          this.closeDialog();
          this.alert("success", "Thêm mới trường thành công");
          this.$set(this.app, "columnListAll", [...this.app.columnListAll, response.data]);
          this.$emit('field-added', response.data);
          this.id = 1;
        }
        else{
          this.alert("error", response.error.message);
        }
      } catch (error) {
        this.alert("error", "Có lỗi xảy ra khi lưu dữ liệu.");
      }
    }
  },
};
</script>
<style lang="scss" scoped>
/* .d-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
} */
.custom-button {
  padding: 5px 8px;
  height: 32px;
  cursor: pointer;
  display: inline-block;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  text-align: center;
}

.custom-button:hover {
  background-color: #f5f5f5;
}

.active-button {
  background-color: #eff5ff;
  color: #327ae7;
  border-color: #409eff;
  font-weight: bold;
}
.icon-style {
  margin-right: 5px;
  font-size: 12px;
  color: #333;
}
.form-check-inline {
  display: inline-block;
  padding-left: 0;
  margin-right: 10px;
}

.form-check-input {
  position: relative;
  margin-top: 0.3rem;
  margin-left: 0;
}

.btn-operator {
  width: 24px;
  height: 24px;
  background-color: #f8f9fa;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;
}

.btn-operator:hover {
  background-color: #e2e6ea;
}
.custom-el-input >>> .el-input__inner {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.icon-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 22px;
  height: 32px;
  border: 1px solid #ddd;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.icon-up,
.icon-down {
  font-size: 20px;
  cursor: pointer;
}

.list-select {
  border: 1px #ddd solid;
  padding: 4px 8px;
  border-radius: 4px;
}

.color {
  display: flex;
  position: relative;
  width: 14px;
  height: 14px;
  border-radius: 4px;
  cursor: pointer;
}

.color::after {
  content: "";
  position: absolute;
  top: 10px;
  left: 0px;
  background-color: transparent;
  padding: 8px 20px;
  display: none;
  z-index: 10; 
}

.color:hover::after {
  display: block;
}

.color-picker {
  display: flex;
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  padding: 5px;
  border-radius: 4px;
  z-index: 10;
  top: 16px;
}

.color-option {
  width: 14px;
  height: 14px;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 5px;
  opacity: 32%;
}

.color-option.select{
  opacity: 1;
}

.color-option:hover {
  transform: scale(1.2);
  transition: transform 0.2s ease-in-out;
  opacity: 1;
}

.tag{
  min-width: max-content; 
  padding: 2px 4px 2px 6px;
  border-radius: 4px;
  background: #ECECEC;
}

.input-select >>> input {
  border: none;
  padding: 0;
}

.error-message {
  margin-left: 4px;
  color: #CF4547;
  font-size: 12px;
  margin-top: 4px;
  font-style: italic;
}

.el-scrollbar .el-select-dropdown__wrap.el-scrollbar__wrap {
  margin-bottom: -24px!important;
}
.el-scrollbar >>> .el-scrollbar__thumb{
  display: none!important;;
}
.text-overflow {
  white-space: nowrap;        
  overflow: hidden;    
  text-overflow: ellipsis;    
}

.custom-pick-date {
  ::v-deep input {
    padding: 0 15px !important;
  }

  ::v-deep .el-input__prefix {
    right: 15px !important;
    left: auto !important;
  }
}
</style>
  